export default "__VITE_ASSET__BFK6A2kA__"